import React, { useState } from 'react';
import { Button, Field } from 'ui';
import SimpleModal from '~/components/NewModal/SimpleModal';
import { usePageViewData } from '~/contexts/PageViewDataContext';
import useFacetFiltering from '~/contexts/facetFiltering/useFacetFiltering';

interface Props {}

const QueryGrabberButton: React.FC<Props> = () => {
  const [open, setOpen] = useState(false);
  const { filterState } = useFacetFiltering();
  const { allData } = usePageViewData();
  const { id, ...modifiedState } = filterState;

  const stringified = JSON.stringify(modifiedState);

  const modelState = JSON.stringify({
    category_id: filterState.category?.[0],
    brand_id: filterState.brand?.[0],
  });

  // Wow, brutally bad.
  const modelIds = allData
    ?.find(a => a?.find?.(f => f.slug && f.id && f.name))
    ?.map(m => m.id)
    ?.join(',');

  return (
    <>
      <Button
        className="flex-shrink-0"
        color="turf-green"
        onClick={() => setOpen(true)}
      >
        Query Grabber
      </Button>
      <SimpleModal
        open={open}
        onClose={() => setOpen(false)}
        title="Query Grabber"
      >
        <Field
          label="Query"
          value={stringified}
          onChange={() => null}
          onFocus={e => e.target.select()}
        />

        <Field
          label="Model Query"
          value={modelState}
          onChange={() => null}
          onFocus={e => e.target.select()}
        />

        <Field
          label="Model IDs"
          value={
            modelIds
              ? JSON.stringify({ include_ids: modelIds })
              : 'No model IDs'
          }
          onChange={() => null}
          onFocus={e => e.target.select()}
        />
      </SimpleModal>
    </>
  );
};

export default QueryGrabberButton;
